import { z } from 'zod';

/**
 * @deprecated - add events to /types/analytics/index.ts.
 */
export const EVENT_NAME = {
  LOGIN_CONTINUE_CLICK: 'login_continue_click',
  LOGIN_INITIATED: 'login_initiated',
  LOGIN_FAILED: 'login_failed',
  LOGIN_SUCCESS: 'login_success',
  LOGIN_CANCELED: 'login_canceled',
  LOGIN_LOGGED_IN: 'login_logged_in',
  LOGIN_RESUBMIT_CODE: 'login_resubmit_code',
  SIGN_UP_RESUBMIT_CODE: 'sign_up_resubmit_code',
  SIGN_UP_INITIATED: 'sign_up_initiated',
  SIGN_UP_COMPLETED: 'sign_up_completed',
  SIGN_UP_PERSONAL_DETAILS_ADDED: 'sign_up_personal_details_added',
  SIGN_UP_CONTACT_DETAILS_ADDED: 'sign_up_contact_details_added',
  SIGN_UP_ADD_CONTACT_DETAILS_LATER: 'sign_up_add_contact_details_later',
  CHECKOUT_SHOW_MORE_PAYMENT_OPTIONS_CLICK: 'checkout_show_more_payment_options_click',
  VALIDATION_FAIL: 'validation_fail',
  TYPEFORM_FIRST_STEP_CLICK: 'typeform_first_step_click',
  TYPEFORM_SUBMIT_CLICK: 'typeform_submit_click',
  CHANGE_BOOKING_TIME_SUCCESS: 'change_booking_time_success',
  CONFIRM_DELETE_PAYMENT_CARD_CLICK: 'confirm_delete_payment_card_click',
  ADD_PAYMENT_CARD_CLICK: 'add_payment_card_click',
  SAVE_PAYMENT_CARD_DETAILS_CLICK: 'save_payment_card_details_click',
  NEW_DOWNLOAD_APP_BANNER_CLICK: 'new_download_app_banner_click',
  NPS_FORM_VIEWED: 'nps_form_viewed',
  NPS_SUBMITTED: 'nps_submitted',
  SUPPORT_FORM_SUBMITTED: 'support_form_submitted',
} as const;

/**
 * When a value is absent, it is represented by BLANK_VALUE.
 */
export const BLANK_VALUE = 'blank' as const;

export const CHARGE_ADJUSTMENT = {
  UNIVERSAL_GIFTCARD: 'universal_giftcard',
  WELLNESS_CARD: 'wellness_card',
  VALUE_CARD: 'value_card',
  BUNDLE: 'bundle',
} as const;

export const PAYMENT_METHOD = {
  PAY_IN_SALON: 'pay_in_salon',
  KLARNA: 'klarna',
  QLIRO: 'qliro',
  CARD: 'card',
  GOOGLE_PAY: 'google_pay',
  APPLE_PAY: 'apple_pay',
  SWISH: 'swish',
} as const;

/**
 * @deprecated - use SCREEN_NAME instead.
 * Do not add new screen names here.
 */
export const SCREEN_VIEW = {
  ADD_PAYMENT_CARD_OVERLAY: 'add_paymentcard_overlay',
  UPDATE_PROFILE: 'update_profile',
  UPDATE_PROFILE_SUCCESS: 'update_profile_success',
  UPDATE_PROFILE_FAIL: 'update_profile_fail',
  SELECT_PAYMENT_METHOD: 'select_payment_method',
  SELECT_PAYMENT_CARD: 'select_payment_card',
  CHECKOUT_ADD_GIFT_CARD: 'checkout_add_gift_card',
  CHECKOUT_ADD_WELLNESS_CARD: 'checkout_add_wellness_card',
  CHECKOUT_ADD_VALUE_CARD: 'checkout_add_value_card',
  CHECKOUT_GIFTCARD_SUMMARY: 'checkout_giftcard_summary',
  ADD_PAYMENT_CARD_DETAILS: 'add_payment_card_details',
  MANAGE_PAYMENT_CARD: 'manage_payment_card',
  DELETE_PAYMENT_CARD: 'delete_payment_card',
  DELETE_PAYMENT_CARD_SUCCESS: 'delete_payment_card_success',
  DELETE_PAYMENT_CARD_ERROR: 'delete_payment_card_error',
  PRACTITIONER_TERMS: 'practitioner_terms',
  GENERAL_TERMS: 'general_terms',
  CHECKOUT_ADD_TO_CALENDAR: 'checkout_add_to_calendar',
  OTP_LOGIN_VERIFY: 'otp_login_verify',
  LOGIN_START: 'login_start',
  LOGIN_SUCCESS: 'login_success',
  LOGIN_FAIL: 'login_fail',
  CREATE_PROFILE_STEP_1: 'create_profile_1/2',
  CREATE_PROFILE_STEP_2: 'create_profile_2/2',
  ACTIVATE_LOCATION: 'activate_location',
  PROMPT_OPTIONAL_EMAIL_FIELD: 'prompt_optional_email_field',
  EMAIL_REQUIRED_LOGIN: 'email_required_login',
  PARTICIPANT_DETAILS: 'participant_details',
  NEW_DOWNLOAD_APP_BANNER: 'new_download_app_banner',
  NPS: 'nps_sheet',
  NPS_COMPLETED: 'nps_sheet_completed',
  HOME: 'home',
  FAVORITES: 'favorites',
  MY_BOOKINGS_UPCOMING: 'my_bookings_upcoming',
  MY_BOOKINGS_FINISHED: 'my_bookings_finished',
  PLACE_LANDING: 'place_landing',
} as const;

export const SCREEN_NAME = {
  ABOUT: 'about',
  APP: 'app',
  BLOG: 'blog',
  BLOG_CATEGORY: 'blog_category',
  BLOG_POST: 'blog_post',
  BOOKING_CHOOSE_TIME: 'booking_step_choose_time',
  BOOKING_DETAILS: 'booking_details',
  BUNDLE_DETAILS: 'bundle_details',
  CANCEL_BOOKING: 'cancel_booking',
  CHECKOUT_BOOKING_CONFIRMATION: 'checkout_booking_confirmation',
  CHECKOUT_BOOKING_KLARNA_SUMMARY: 'checkout_booking_klarna_summary',
  CHECKOUT_BOOKING_KLARNA_UPDATE_PAYMENT_METHOD: 'checkout_booking_klarna_update_payment_method',
  CHECKOUT_BOOKING_QLIRO_SUMMARY: 'checkout_booking_qliro_summary',
  CHECKOUT_BOOKING_QLIRO_UPDATE_PAYMENT_METHOD: 'checkout_booking_qliro_update_payment_method',
  CHECKOUT_BOOKING_SUMMARY: 'checkout_booking_summary',
  CHECKOUT_BOOKING_SWISH_SUMMARY: 'checkout_booking_swish_summary',
  CHECKOUT_BOOKING_SWISH_UPDATE_PAYMENT_METHOD: 'checkout_booking_swish_update_payment_method',
  CHECKOUT_BOOKING_UPDATE_PAYMENT_METHOD: 'checkout_booking_update_payment_method',
  CHECKOUT_BOOKING_UPDATE_PAYMENT_METHOD_CONFIRMATION: 'checkout_booking_update_payment_method_confirmation',
  CHECKOUT_BUNDLE_CONFIRMATION: 'checkout_bundle_confirmation',
  CHECKOUT_BUNDLE_QLIRO_SUMMARY: 'checkout_bundle_qliro_summary',
  CHECKOUT_BUNDLE_SUMMARY: 'checkout_bundle_summary',
  CHECKOUT_BUNDLE_SWISH_SUMMARY: 'checkout_bundle_swish_summary',
  COMPANY_DETAILS: 'company_details',
  COOKIE_POLICY: 'cookie_policy',
  DEALS: 'deals',
  DEALS_MAP: 'deals_map',
  ETHICAL_POLICY: 'ethical_policy',
  FACTS: 'facts_and_advice',
  FAQ: 'faq',
  FAVORITES: 'favorites',
  GIFTCARD_CHECKOUT: 'gift_card_landing_page',
  GIFTCARD_USE: 'check_giftcard_wellnesscard_value',
  GOTO: 'goto',
  HOME: 'home',
  INJECTION_NOTICE: 'injection_notice',
  MY_BOOKINGS_DETAILS: 'my_bookings_booking_detail',
  MY_BOOKINGS_FINISHED: 'my_bookings_finished',
  MY_BOOKINGS_UPCOMING: 'my_bookings_upcoming',
  MY_BUNDLE_OVERVIEW: 'my_bundles_overview',
  MY_PROFILE: 'my_profile',
  PAYMENT_METHODS: 'payment_methods',
  PLACE_LANDING: 'place_landing',
  PLACE_VALUECARD_LANDING: 'place_value_card_landing_page',
  PORTAL: 'portal',
  PRIVACY_POLICY: 'privacy_policy',
  SEARCH_NOTICE: 'search_notice',
  SEARCH_RESULTS: 'search_results',
  SEARCH_RESULTS_MAP: 'search_results_map',
  SECURITY_ACKNOWLEDGEMENTS: 'security_acknowledgements',
  SECURITY_POLICY: 'security_policy',
  SUPPORT: 'support',
  SUPPORT_FORM: 'support_form',
  TERMS_BOOKING_CONSUMER: 'terms',
  TERMS_GIFTCARD_CONSUMER: 'terms_giftcard',
  TERMS_LANDING: 'terms_landing',
  TERMS_ONLINE_PAYMENT: 'terms_online_payment',
  WELLNESS_CARD_CHECKOUT: 'wellness_card_landing_page',
  TERMS: 'terms',
  NEWSLETTER: 'newsletter',
  UNSUBSCRIBE: 'unsubscribe',
  UNSUBSCRIBE_REVIEWS: 'unsubscribe_reviews',
  ADD_REVIEW: 'add_review',
  CHECK_GIFTCARD: 'check_giftcard_wellnesscard_value',
  FACTS_AND_ADVICE: 'facts_and_advice',
} as const;

export const screenNameSchema = z.enum([
  SCREEN_NAME.ABOUT,
  SCREEN_NAME.APP,
  SCREEN_NAME.BLOG,
  SCREEN_NAME.BLOG_CATEGORY,
  SCREEN_NAME.BLOG_POST,
  SCREEN_NAME.BOOKING_CHOOSE_TIME,
  SCREEN_NAME.BOOKING_DETAILS,
  SCREEN_NAME.BUNDLE_DETAILS,
  SCREEN_NAME.CANCEL_BOOKING,
  SCREEN_NAME.CHECKOUT_BOOKING_CONFIRMATION,
  SCREEN_NAME.CHECKOUT_BOOKING_KLARNA_SUMMARY,
  SCREEN_NAME.CHECKOUT_BOOKING_KLARNA_UPDATE_PAYMENT_METHOD,
  SCREEN_NAME.CHECKOUT_BOOKING_QLIRO_SUMMARY,
  SCREEN_NAME.CHECKOUT_BOOKING_QLIRO_UPDATE_PAYMENT_METHOD,
  SCREEN_NAME.CHECKOUT_BOOKING_SWISH_SUMMARY,
  SCREEN_NAME.CHECKOUT_BOOKING_SWISH_UPDATE_PAYMENT_METHOD,
  SCREEN_NAME.CHECKOUT_BOOKING_SUMMARY,
  SCREEN_NAME.CHECKOUT_BOOKING_UPDATE_PAYMENT_METHOD,
  SCREEN_NAME.CHECKOUT_BOOKING_UPDATE_PAYMENT_METHOD_CONFIRMATION,
  SCREEN_NAME.CHECKOUT_BUNDLE_CONFIRMATION,
  SCREEN_NAME.CHECKOUT_BUNDLE_QLIRO_SUMMARY,
  SCREEN_NAME.CHECKOUT_BUNDLE_SUMMARY,
  SCREEN_NAME.CHECKOUT_BUNDLE_SWISH_SUMMARY,
  SCREEN_NAME.COMPANY_DETAILS,
  SCREEN_NAME.COOKIE_POLICY,
  SCREEN_NAME.DEALS,
  SCREEN_NAME.DEALS_MAP,
  SCREEN_NAME.ETHICAL_POLICY,
  SCREEN_NAME.FACTS,
  SCREEN_NAME.FAQ,
  SCREEN_NAME.FAVORITES,
  SCREEN_NAME.GIFTCARD_CHECKOUT,
  SCREEN_NAME.GIFTCARD_USE,
  SCREEN_NAME.GOTO,
  SCREEN_NAME.HOME,
  SCREEN_NAME.INJECTION_NOTICE,
  SCREEN_NAME.MY_BOOKINGS_DETAILS,
  SCREEN_NAME.MY_BOOKINGS_FINISHED,
  SCREEN_NAME.MY_BOOKINGS_UPCOMING,
  SCREEN_NAME.MY_BUNDLE_OVERVIEW,
  SCREEN_NAME.MY_PROFILE,
  SCREEN_NAME.PAYMENT_METHODS,
  SCREEN_NAME.PLACE_LANDING,
  SCREEN_NAME.PLACE_VALUECARD_LANDING,
  SCREEN_NAME.PORTAL,
  SCREEN_NAME.PRIVACY_POLICY,
  SCREEN_NAME.SEARCH_NOTICE,
  SCREEN_NAME.SEARCH_RESULTS,
  SCREEN_NAME.SEARCH_RESULTS_MAP,
  SCREEN_NAME.SECURITY_ACKNOWLEDGEMENTS,
  SCREEN_NAME.SECURITY_POLICY,
  SCREEN_NAME.SUPPORT,
  SCREEN_NAME.SUPPORT_FORM,
  SCREEN_NAME.TERMS_BOOKING_CONSUMER,
  SCREEN_NAME.TERMS_GIFTCARD_CONSUMER,
  SCREEN_NAME.TERMS_LANDING,
  SCREEN_NAME.TERMS_ONLINE_PAYMENT,
  SCREEN_NAME.WELLNESS_CARD_CHECKOUT,
]);

export const BANNER_TYPE = {
  GENERAL_BANNER: 'general_banner',
} as const;
